import { render, staticRenderFns } from "./StylingDresser.vue?vue&type=template&id=e1e35a54&scoped=true&"
import script from "./StylingDresser.vue?vue&type=script&lang=js&"
export * from "./StylingDresser.vue?vue&type=script&lang=js&"
import style0 from "./StylingDresser.vue?vue&type=style&index=0&id=e1e35a54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e35a54",
  null
  
)

export default component.exports